import {
  createCheckpointGroup,
  findByGroupId,
  updateCheckpointGroup,
  findEquipmentsByCheckpointGroup,
} from '@/api/checkpoint-group/checkpoint-group';
import { CheckpointGroup } from '@/api/entities/checkpointGroup';
import { ErrorResponse } from '@/utils/axios.http';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useGetCheckpointGroupById = (groupId: string) => {
  return useQuery({
    queryKey: ['getCheckpointGroupById', groupId],
    queryFn: () => findByGroupId(groupId),
  });
};

export const useCreateCheckPoinGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CheckpointGroup) => createCheckpointGroup(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCheckpointGroupById'] });
      queryClient.invalidateQueries({
        queryKey: ['getEquipmentsByCheckpointGroup'],
      });
    },
    onError: (error: ErrorResponse) => {
      console.error(error.error);
    },
  });
};

export const useUpdateCheckpointGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CheckpointGroup) => updateCheckpointGroup(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCheckpointGroupById'] });
      queryClient.invalidateQueries({
        queryKey: ['getEquipmentsByCheckpointGroup'],
      });
    },
    onError: (error: ErrorResponse) => {
      console.error(error.error);
    },
  });
};

export const useGetEquipmentsByCheckpointGroup = (
  groupId: string,
  checkpointId: string,
) => {
  return useQuery({
    queryKey: ['getEquipmentsByCheckpointGroup', groupId, checkpointId],
    queryFn: () => findEquipmentsByCheckpointGroup(groupId, checkpointId),
  });
};
